/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expand': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g><g><g _stroke="#000"><polyline pid="0" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="10.5,19.5 3.5,19.5 3.5,12.5"/><polyline pid="1" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="20.5,9.5 20.5,2.5 13.5,2.5"/><line pid="2" _fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="3.5" y1="19.5" x2="20.5" y2="2.5"/></g></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/expand.js